export default __webpack_public_path__ + "static/media/who-created-git.f3de41e9.png";